import { IconProps } from '.';

const LocationSelectedIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 48 58"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <path
        d="M40.934 40.5961L24.3757 57.154L7.8176 40.5961C-1.32722 31.4513 -1.32722 16.6245 7.8176 7.47971C16.9624 -1.66511 31.7891 -1.66511 40.934 7.47971C50.0785 16.6245 50.0785 31.4513 40.934 40.5961Z"
        fill={color || `var(--color-orange-300)`}
      />
      <ellipse
        cx="24.38"
        cy="24.173"
        rx="8.98549"
        ry="8.98549"
        // this should always be white according to designs
        fill="var(--color-white)"
      />
    </svg>
  );
};

export default LocationSelectedIcon;
